import React from "react";
import Dashboard from "../components/dashboard/dashboard";
import Addstaff from "../components/dashboard/staff/addstaff";
import Allstaff from "../components/dashboard/staff/allstaff";
import DeletedStaff from "../components/dashboard/staff/deletedstaff";
import Addmember from "../components/dashboard/member/addmember";
import Allmembers from "../components/dashboard/member/allmembers";
import DeletedMember from "../components/dashboard/member/deletedmember";
import DeletedGroup from "../components/dashboard/group/deletedgroup";
import DeletedLoan from "../components/dashboard/loan/deletedloan";
import Addgroup from "../components/dashboard/group/addgroup";
import Allgroup from "../components/dashboard/group/allgroup";
import Loanapproval from "../components/dashboard/loan/loanapproval";
import Allloan from "../components/dashboard/loan/allloan";
import Memberprofile from "../components/dashboard/member/memberprofile";
import Addcollection from "../components/dashboard/collection/addcollection";
import Allcollection from "../components/dashboard/collection/allcollection";
import AddIndividualCollection from "../components/dashboard/collection/addindividualcollection";
import AllIndividualCollection from "../components/dashboard/collection/allindividualcollection";
import AutoPosting from "../components/dashboard/collection/autoposting";
import BankList from "../components/dashboard/master/banklist";
import Reports from "../components/dashboard/reports";
import Addscheme from "../components/dashboard/master/scheme/addscheme";
import { ListScheme } from "../components/dashboard/master/scheme/listscheme";
import { ListBranch } from "../components/dashboard/master/listbranch";
import { Designation } from "../components/dashboard/master/designation";
import { ListRole } from "../components/dashboard/master/role";
import { Settings } from "../components/dashboard/settings";
import PrivacyPolicy from "../components/dashboard/settings/privacypolicy";
import { Religion } from "../components/dashboard/master/religion";
import { Caste } from "../components/dashboard/master/caste";
import { Subcaste } from "../components/dashboard/master/subcaste";
import AddLoan from "../components/dashboard/loan/addloan";
import AddIndividualLoan from "../components/dashboard/individualloan/addindividualloan";
import IndividualLoanApproval from "../components/dashboard/individualloan/individualloanapproval";
import { DateCollection } from "../components/dashboard/collection/datecollection";
import { CollectionSheet } from "../components/dashboard/reports/collectionsheet";
import { LoanDisburse } from "../components/dashboard/reports/loandisburse";
import { Denomination } from "../components/dashboard/reports/denomination";
import MemberLoan from "../components/dashboard/member/membersloan";
import { OutstandingSheet } from "../components/dashboard/reports/outstandingsheet";
import PreLoancollection from "../components/dashboard/preloan/addposting";
import { NOCSheet } from "../components/dashboard/reports/nocreport";
import AllPayslip from "../components/dashboard/payslip/allpayslip";
import AddPayslip from "../components/dashboard/payslip/addpayslip";
import SalaryStructure from "../components/dashboard/payslip/salarystructure";
import BulkGenerate from "../components/dashboard/payslip/bulkgenerate";
import AllAccounts from "../components/dashboard/accounts/chartofaccounts/allaccounts";
import AddAccount from "../components/dashboard/accounts/chartofaccounts/addaccount";
import AllVouchers from "../components/dashboard/accounts/vouchers/allvouchers";
import AddVoucher from "../components/dashboard/accounts/vouchers/addvoucher";
import TrialBalance from "../components/dashboard/accounts/reports/trialbalance";
import CashBook from "../components/dashboard/accounts/reports/cashbook";
import ProfitAndLoss from "../components/dashboard/accounts/reports/profitandloss";
import BalanceSheet from "../components/dashboard/accounts/reports/balancesheet";
import CashFlow from "../components/dashboard/accounts/reports/cashflow";
import GeneralLedger from "../components/dashboard/accounts/reports/generalledger";
import Daybook from "../components/dashboard/accounts/reports/daybook";
import FinancialYear from "../components/dashboard/accounts/financialyear";
import MigrateLoanData from "../components/dashboard/accounts/settings/MigrateLoanData";
import AllBudgets from "../components/dashboard/accounts/budget/allbudgets";
import BudgetVsActual from "../components/dashboard/accounts/budget/budgetvsactual";
import BudgetAlerts from "../components/dashboard/accounts/budget/budgetalerts";
import AssetCategories from "../components/dashboard/accounts/assets/assetcategories";
import AllFixedAssets from "../components/dashboard/accounts/assets/allfixedassets";
import AuditTrail from "../components/dashboard/accounts/audittrail";
import ManagementDashboard from "../components/dashboard/analytics/managementdashboard";
import AllAccountTypes from "../components/dashboard/master/accounttypes/AllAccountTypes";
import AddAccountType from "../components/dashboard/master/accounttypes/AddAccountType";
import AllAccountGroups from "../components/dashboard/master/accountgroups/AllAccountGroups";
import AddAccountGroup from "../components/dashboard/master/accountgroups/AddAccountGroup";
import FinancialAnalysis from "../components/dashboard/analytics/financialanalysis";
import RolePermissions from "../components/settings/rolepermissions";
import MenuPermission from "../components/dashboard/settings/menupermission";
import UserPermissions from "../components/settings/userpermissions";
import BranchAccess from "../components/settings/branchaccess";
import ApprovalWorkflows from "../components/settings/approvalworkflows";
import PendingApprovals from "../components/dashboard/pendingapprovals";
import TaxConfiguration from "../components/tax/taxconfiguration";
import TdsDeductions from "../components/tax/tdsdeductions";
import GstReturns from "../components/tax/gstreturns";
import TaxReports from "../components/tax/taxreports";
import BackupManagement from "../components/settings/backupmanagement";
import SecurityDashboard from "../components/settings/securitydashboard";
import NotificationManagement from "../components/notifications/notificationmanagement";
import ImportExport from "../components/data/importexport";
import RecurringTransactions from "../components/transactions/recurringtransactions";
import IndividualReport from "../components/dashboard/reports/individualreport";
import JobAllocation from "../components/dashboard/joballocation/joballocation";
import ClockInOut from "../components/dashboard/attendance/clockinout";
import AttendanceList from "../components/dashboard/attendance/attendancelist";
import SendSms from "../components/dashboard/communication/sendsms";
import ListSms from "../components/dashboard/communication/listsms";
import SmsTemplates from "../components/dashboard/communication/smstemplates";
import SendPush from "../components/dashboard/pushnotification/sendpush";
import ListPush from "../components/dashboard/pushnotification/listpush";
import NPALoansReport from "../components/dashboard/reports/npaloansreport";
import RbiNbfcCompliance from "../components/reports/rbinbfccompliance";
import MemberDashboard from "../components/member/memberdashboard";
import Policy from "../components/policy";

export const dashboardroutes = [
  {
    id: 1,
    path: "/superadmin/dashboard",
    exact: false,
    element: <Dashboard />,
  },
  {
    id: 900,
    path: "/member/dashboard",
    exact: false,
    element: <MemberDashboard />,
  },
  {
    id: 901,
    path: "/member/loans",
    exact: false,
    element: <MemberDashboard />,
  },
  {
    id: 902,
    path: "/member/outstanding",
    exact: false,
    element: <MemberDashboard />,
  },
  {
    id: 2,
    path: "/staff/addstaff",
    exact: false,
    element: <Addstaff />,
  },
  {
    id: 3,
    path: "/staff/allstaff",
    exact: false,
    element: <Allstaff />,
  },
  {
    id: 903,
    path: "/staff/deletedstaff",
    exact: false,
    element: <DeletedStaff />,
  },
  {
    id: 4,
    path: "/member/addmember",
    exact: false,
    element: <Addmember />,
  },
  {
    id: 5,
    path: "/member/allmembers",
    exact: false,
    element: <Allmembers />,
  },
  {
    id: 6,
    path: "/group/addgroup",
    exact: false,
    element: <Addgroup />,
  },
  {
    id: 7,
    path: "/group/allgroup",
    exact: false,
    element: <Allgroup />,
  },
  {
    id: 906,
    path: "/group/deletedgroup",
    exact: false,
    element: <DeletedGroup />,
  },
  {
    id: 907,
    path: "/member/deletedmember",
    exact: false,
    element: <DeletedMember />,
  },
  {
    id: 908,
    path: "/loan/deletedloan",
    exact: false,
    element: <DeletedLoan />,
  },
  {
    id: 8,
    path: "/master/addscheme",
    exact: false,
    element: <Addscheme />,
  },
  {
    id: 9,
    path: "/master/schemelist",
    exact: false,
    element: <ListScheme />,
  },
  {
    id: 10,
    path: "/loan/loanapproval",
    exact: false,
    element: <Loanapproval />,
  },
  {
    id: 11,
    path: "/loan/allloan",
    exact: false,
    element: <Allloan />
  },
  {
    id: 1001,
    path: "/individualloan/add/:id",
    exact: false,
    element: <AddIndividualLoan />
  },
  {
    id: 1002,
    path: "/individualloan/approval",
    exact: false,
    element: <IndividualLoanApproval />
  },
  {
    id: 12,
    path: "/member/memberprofile/:id",
    exact: false,
    element: <Memberprofile />
  },
  {
    id: 13,
    path: "/collection/addcollection",
    exact: false,
    element: <Addcollection />
  },
  {
    id: 14,
    path: "/collection/allcollection",
    exact: false,
    element: <Allcollection />
  },
  {
    id: 14.1,
    path: "/collection/addindividualcollection",
    exact: false,
    element: <AddIndividualCollection />
  },
  {
    id: 14.2,
    path: "/collection/allindividualcollection",
    exact: false,
    element: <AllIndividualCollection />
  },
  {
    id: 14.3,
    path: "/collection/editindividualcollection/:id/:mid",
    exact: false,
    element: <AddIndividualCollection />
  },
  {
    id: 15,
    path: "/master/branchlist",
    exact: false,
    element: <ListBranch />
  },
  {
    id: 15.1,
    path: "/master/banklist",
    exact: false,
    element: <BankList />
  },
  {
    id: 16,
    path: "/master/designationlist",
    exact: false,
    element: <Designation />
  },
  {
    id: 17,
    path: "/master/rolelist",
    exact: false,
    element: <ListRole />
  },
  {
    id: 18,
    path: "/superadmin/incomeexpences",
    exact: false,
    element: <Dashboard />,
  },
  {
    id: 19,
    path: "/superadmin/income",
    exact: false,
    element: <Dashboard />,
  },
  {
    id: 20,
    path: "/superadmin/expences",
    exact: false,
    element: <Dashboard />,
  },
  {
    id: 20,
    path: "/superadmin/reports",
    exact: false,
    element: <Dashboard />,
  },
  {
    id: 21,
    path: "/master/schemedetail/:id",
    exact: false,
    element: <Addscheme />,
  },
  {
    id: 22,
    path: "/superadmin/settings",
    exact: false,
    element: <Settings />,
  },
  {
    id: 23,
    path: "/staff/staffdetail/:id",
    exact: false,
    element: <Addstaff />,
  },
  {
    id: 24,
    path: "/master/religionlist",
    exact: false,
    element: <Religion />,
  },
  {
    id: 25,
    path: "/master/castelist",
    exact: false,
    element: <Caste />,
  },
  {
    id: 26,
    path: "/master/subcastelist",
    exact: false,
    element: <Subcaste />,
  },
  {
    id: 26.1,
    path: "/master/accounttypes",
    exact: false,
    element: <AllAccountTypes />,
  },
  {
    id: 26.2,
    path: "/master/addaccounttype",
    exact: false,
    element: <AddAccountType />,
  },
  {
    id: 26.3,
    path: "/master/editaccounttype/:id",
    exact: false,
    element: <AddAccountType />,
  },
  {
    id: 26.4,
    path: "/master/accountgroups",
    exact: false,
    element: <AllAccountGroups />,
  },
  {
    id: 26.5,
    path: "/master/addaccountgroup",
    exact: false,
    element: <AddAccountGroup />,
  },
  {
    id: 26.6,
    path: "/master/editaccountgroup/:id",
    exact: false,
    element: <AddAccountGroup />,
  },
  {
    id: 27,
    path: "/group/groupdetail/:id",
    exact: false,
    element: <Addgroup />,
  },
  {
    id: 28,
    path: "/member/memberdetail/:id",
    exact: false,
    element: <Addmember />,
  },
  {
    id: 29,
    path: "/loan/memberlist/:id",
    exact: false,
    element: <Allmembers />,
  },
  {
    id: 30,
    path: "/loan/addloan/:id",
    exact: false,
    element: <AddLoan />
  },
  {
    id: 31,
    path: "/collection/datewisecollection/:id",
    exact: false,
    element: <DateCollection />
  },
  {
    id: 32,
    path: "/reports/collectionsheet",
    exact: false,
    element: <CollectionSheet />
  },
  {
    id: 33,
    path: "/reports/topcollectionsheet",
    exact: false,
    element: <CollectionSheet />
  },
  {
    id: 34,
    path: "/reports/summary",
    exact: false,
    element: <CollectionSheet />
  },
  {
    id: 35,
    path: "/reports/loandisbursement",
    exact: false,
    element: <LoanDisburse />
  },
  {
    id: 36,
    path: "/reports/denomination",
    exact: false,
    element: <Denomination />
  },
  {
    id: 37,
    path: "/reports/dailycollectionsheet",
    exact: false,
    element: <CollectionSheet />
  },
  {
    id: 38,
    path: "/reports/pendingcollectionsheet",
    exact: false,
    element: <CollectionSheet />
  },
  {
    id: 39,
    path: "/member/groupmemberdetail/:id/:gid",
    exact: false,
    element: <Addmember />,
  },
  {
    id: 40,
    path: "/member/groupmemberprofile/:id/:gid",
    exact: false,
    element: <Memberprofile />
  },
  {
    id: 41,
    path: "/member/memberloanlist/:id/",
    exact: false,
    element: <MemberLoan />
  },
  {
    id: 42,
    path: "/reports/outstanding",
    exact: false,
    element: <OutstandingSheet />
  },
  {
    id: 43,
    path: "/employee/dashboard",
    exact: false,
    element: <Dashboard />
  },
  {
    id: 44,
    path: "/reports/staffwisecollection",
    exact: false,
    element: <CollectionSheet />
  },
  {
    id: 45,
    path: "/collection/editcollection/:id/:gid",
    exact: false,
    element: <Addcollection />
  },
  {
    id: 46,
    path: "/preloan/addcollection",
    exact: false,
    element: <PreLoancollection />
  },
  {
    id: 47,
    path: "/preloan/listcollection",
    exact: false,
    element: <Allcollection />
  },
  {
    id: 48,
    path: "/reports/preloanreport",
    exact: false,
    element: <CollectionSheet />
  },
  {
    id: 49,
    path: "/reports/nocreport",
    exact: false,
    element: <NOCSheet />
  },
  {
    id: 50,
    path: "/payslip/allpayslip",
    exact: false,
    element: <AllPayslip />
  },
  {
    id: 904,
    path: "/payslip/salarystructure",
    exact: false,
    element: <SalaryStructure />
  },
  {
    id: 905,
    path: "/payslip/bulkgenerate",
    exact: false,
    element: <BulkGenerate />
  },
  {
    id: 51,
    path: "/payslip/addpayslip",
    exact: false,
    element: <AddPayslip />
  },
  {
    id: 52,
    path: "/payslip/editpayslip/:id",
    exact: false,
    element: <AddPayslip />
  },
  {
    id: 53,
    path: "/accounts/allaccounts",
    exact: false,
    element: <AllAccounts />
  },
  {
    id: 54,
    path: "/accounts/addaccount",
    exact: false,
    element: <AddAccount />
  },
  {
    id: 55,
    path: "/accounts/editaccount/:id",
    exact: false,
    element: <AddAccount />
  },
  {
    id: 56,
    path: "/accounts/allvouchers",
    exact: false,
    element: <AllVouchers />
  },
  {
    id: 57,
    path: "/accounts/addvoucher",
    exact: false,
    element: <AddVoucher />
  },
  {
    id: 58,
    path: "/accounts/editvoucher/:id",
    exact: false,
    element: <AddVoucher />
  },
  {
    id: 59,
    path: "/accounts/viewvoucher/:id",
    exact: false,
    element: <AddVoucher />
  },
  {
    id: 60,
    path: "/accounts/trialbalance",
    exact: false,
    element: <TrialBalance />
  },
  {
    id: 61,
    path: "/accounts/cashbook",
    exact: false,
    element: <CashBook />
  },
  {
    id: 62,
    path: "/accounts/profitandloss",
    exact: false,
    element: <ProfitAndLoss />
  },
  {
    id: 63,
    path: "/accounts/balancesheet",
    exact: false,
    element: <BalanceSheet />
  },
  {
    id: 64,
    path: "/accounts/cashflow",
    exact: false,
    element: <CashFlow />
  },
  {
    id: 65,
    path: "/accounts/generalledger",
    exact: false,
    element: <GeneralLedger />
  },
  {
    id: 66,
    path: "/accounts/daybook",
    exact: false,
    element: <Daybook />
  },
  {
    id: 69,
    path: "/accounts/financialyear",
    exact: false,
    element: <FinancialYear />
  },
  {
    id: 69.5,
    path: "/accounts/settings/migrateloandata",
    exact: false,
    element: <MigrateLoanData />
  },
  {
    id: 70,
    path: "/accounts/budgets",
    exact: false,
    element: <AllBudgets />
  },
  {
    id: 71,
    path: "/accounts/budgetvsactual",
    exact: false,
    element: <BudgetVsActual />
  },
  {
    id: 72,
    path: "/accounts/budgetalerts",
    exact: false,
    element: <BudgetAlerts />
  },
  {
    id: 73,
    path: "/accounts/assetcategories",
    exact: false,
    element: <AssetCategories />
  },
  {
    id: 74,
    path: "/accounts/fixedassets",
    exact: false,
    element: <AllFixedAssets />
  },
  {
    id: 75,
    path: "/accounts/audittrail",
    exact: false,
    element: <AuditTrail />
  },
  {
    id: 76,
    path: "/analytics/managementdashboard",
    exact: false,
    element: <ManagementDashboard />
  },
  {
    id: 78,
    path: "/analytics/financialanalysis",
    exact: false,
    element: <FinancialAnalysis />
  },
  {
    id: 79,
    path: "/settings/rolepermissions",
    exact: false,
    element: <RolePermissions />
  },
  {
    id: 791,
    path: "/settings/menupermission",
    exact: false,
    element: <MenuPermission />
  },
  {
    id: 80,
    path: "/settings/userpermissions",
    exact: false,
    element: <UserPermissions />
  },
  {
    id: 81,
    path: "/settings/branchaccess",
    exact: false,
    element: <BranchAccess />
  },
  {
    id: 82,
    path: "/settings/approvalworkflows",
    exact: false,
    element: <ApprovalWorkflows />
  },
  {
    id: 83,
    path: "/dashboard/pendingapprovals",
    exact: false,
    element: <PendingApprovals />
  },
  {
    id: 84,
    path: "/tax/configuration",
    exact: false,
    element: <TaxConfiguration />
  },
  {
    id: 85,
    path: "/tax/tdsdeductions",
    exact: false,
    element: <TdsDeductions />
  },
  {
    id: 86,
    path: "/tax/gstreturns",
    exact: false,
    element: <GstReturns />
  },
  {
    id: 87,
    path: "/tax/reports",
    exact: false,
    element: <TaxReports />
  },
  {
    id: 89,
    path: "/settings/backupmanagement",
    exact: false,
    element: <BackupManagement />
  },
  {
    id: 90,
    path: "/settings/securitydashboard",
    exact: false,
    element: <SecurityDashboard />
  },
  {
    id: 91,
    path: "/notifications/management",
    exact: false,
    element: <NotificationManagement />
  },
  {
    id: 92,
    path: "/data/importexport",
    exact: false,
    element: <ImportExport />
  },
  {
    id: 93,
    path: "/transactions/recurring",
    exact: false,
    element: <RecurringTransactions />
  },
  {
    id: 94,
    path: "/reports/individualreport",
    exact: false,
    element: <IndividualReport />
  },
  {
    id: 95,
    path: "/joballocation",
    exact: false,
    element: <JobAllocation />
  },
  {
    id: 96,
    path: "/attendance/clockinout",
    exact: false,
    element: <ClockInOut />
  },
  {
    id: 97,
    path: "/attendance/attendancelist",
    exact: false,
    element: <AttendanceList />
  },
  {
    id: 1005,
    path: "/sms/templates",
    exact: false,
    element: <SmsTemplates />
  },
  {
    id: 1003,
    path: "/sms/send",
    exact: false,
    element: <SendSms />
  },
  {
    id: 1004,
    path: "/sms/list",
    exact: false,
    element: <ListSms />
  },
  {
    id: 1006,
    path: "/push/send",
    exact: false,
    element: <SendPush />
  },
  {
    id: 1007,
    path: "/push/list",
    exact: false,
    element: <ListPush />
  },
  {
    id: 98,
    path: "/reports/npaloans",
    exact: false,
    element: <NPALoansReport />
  },
  {
    id: 99,
    path: "/reports/rbicompliance",
    exact: false,
    element: <RbiNbfcCompliance />
  },
  {
    id: 100,
    path: "/settings/privacypolicy",
    exact: false,
    element: <PrivacyPolicy />
  },
  {
    id: 101,
    path: "/collection/autoposting",
    exact: false,
    element: <AutoPosting />
  },

];
export default {
  dashboardroutes,
};
